export enum Formats{
    T = 'Textual',
    N = 'Numerico',
}

export const getDescricaoByCodigoFormat = (codigo: string)=>{
    const values: string[] = Object.values(Formats)
    const keys: string[] = Object.keys(Formats)

    const index = keys.indexOf(codigo)
    return values[index]
}

export const getCodigoByDescricaoFormat = (desc: string)=>{
    const values: string[] = Object.values(Formats)
    const keys: string[] = Object.keys(Formats)

    const index = values.indexOf(desc)
    return keys[index]
}